export default {
  getEngagementTypeId: (state) => state.engagementTypeId,
  getIsGlobalNewslettersReport: (state) => state.isGlobalNewslettersReport,
  getIsDev: (state) => state.isDev,
  getAreStatsLoading: (state) => state.areStatsLoading,
  getPingTimeoutInSeconds: (state) => state.pingTimeoutInSeconds,
  getTimezone: (state) => state.timezone,
  getPickerStartDate: (state) => state.pickerStartDate,
  getPickerEndDate: (state) => state.pickerEndDate,
  getProductStats: (state) => state.productStats,
  getRecommendationProductStats: (state) => state.recommendationProductStats,
  getEngagementStatisticTypesMap: (state) => state.engagementStatisticTypes,
  getPickerOrderIndex: (state) => state.pickerOrderIndex,
  getPickerChannelType: (state) => state.pickerChannelType,
  getPickerEngagementMessageId: (state) => state.pickerEngagementMessageId,
  getEngagement: (state) => state.engagement,
  getTrackerStatistics: (state) => state.trackerStatistics,
  getIsTransactionalEngagement: (state) => state.isTransactionalEngagement,
  getHeaders: (state) => state.headers,
  getSelectedEngagements: (state) => state.selectedEngagements,
  getEngagementsPopularLinks: (state) => state.engagementsPopularLinks,
  getSelectedEngagementsStatistics: (state) => state.selectedEngagementsStatistics,
};
